/**
 * Point d'entrée principal de l'application Vue
 *
 * Responsabilités:
 * - Initialise l'instance Vue et configure les plugins (Pinia, Router)
 * - Charge la session utilisateur au démarrage via Supabase
 * - Monte l'application sur l'élément #app du DOM
 *
 * Ne gère pas:
 * - La logique d'authentification (déléguée à useAuth)
 * - La configuration des routes (déléguée au router)
 * - La gestion d'état globale (déléguée à Pinia)
 *
 * Dépendances: Vue 3, Pinia, Vue Router, Supabase (via useAuth), tokens.css (design tokens)
 */
import "./assets/tailwind.css"
import "./assets/tokens.css"
import "./assets/inbox.css"
import "./assets/role-layout.css"
import "./assets/scrollbars.css"
import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import { createPinia } from 'pinia'
import { useAuth } from '../composables/UseAuth'
import App from './App.vue'
import router from './router'
import { messages, resolveInitialLocale } from '../locales'
import './assets/fullcalendar.css'
import { revealDirective } from './directives/reveal'
import { initializeColorTheme } from './lib/theme'

initializeColorTheme()

function bootstrap() {
  //On créer l'instance vue qui va gérer l'application
  const app = createApp(App)
  const i18n = createI18n({
    legacy: false,
    locale: resolveInitialLocale(),
    fallbackLocale: 'fr',
    messages,
    globalInjection: true,
  })
  //On récupère la fonction loadSessionFromSupabase depuis le composable useAuth (on y stocke la session, le profil utilisateur, et les fonctions de login/logout)
  const { loadSessionFromSupabase } = useAuth()
  // Start restoring the session without blocking public page rendering.
  // Protected routes await this request in the router guard. Public routes can
  // render while the existing session is restored.
  void loadSessionFromSupabase()
  //On configure l'application vue avec le routeur et le store pinia
  app.use(createPinia())
  //on branche le routeur à l'application vue
  app.use(router)
  app.use(i18n)
  app.directive('reveal', revealDirective)
  //on injecte l'application vue dans la page HTML (dans l'élement #app du DOM)
  app.mount('#app')
}

bootstrap()
